import "./lib/authCallbackError.js"; // must run before App/router, see file header
import "./styles/tokens.css";
import "./styles/responsive.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import { PwaStatus } from "./lib/PwaStatus.js";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
    <PwaStatus />
  </React.StrictMode>
);
